const translations: Record<string, string> = {
  // Navbar
  'nav.home': 'หน้าแรก',
  'nav.services': 'บริการ',
  'nav.custom': 'เว็บไซต์',
  'nav.modules': 'โมดูล',
  'nav.brand': 'แบรนด์',
  'nav.contact': 'ติดต่อ',
  'nav.cta': 'ปรึกษาฟรี',

  // Hero
  'hero.badge': 'บริการออกแบบดิจิทัลมืออาชีพ',
  'hero.prefix': 'สร้างสรรค์เพื่อ',
  'hero.h0': 'เว็บไซต์คัสตอม',
  'hero.h1': 'อัตลักษณ์แบรนด์',
  'hero.h2': 'ระบบโมดูล',
  'hero.sub': 'เราผสานกลยุทธ์เชิงลึกกับความงดงามในการออกแบบ เพื่อสร้างประสบการณ์ดิจิทัลที่น่าจดจำ',
  'hero.cta1': 'ดูบริการทั้งหมด',
  'hero.cta2': 'ปรึกษาฟรี',
  'hero.stat0.sfx': '+',
  'hero.stat0.lbl': 'โปรเจกต์สำเร็จ',
  'hero.stat1.sfx': '%',
  'hero.stat1.lbl': 'ความพึงพอใจ',
  'hero.stat2.sfx': '+',
  'hero.stat2.lbl': 'ประสบการณ์',
  'hero.stat3.sfx': '+',
  'hero.stat3.lbl': 'แบรนด์ที่ไว้วางใจ',
  'hero.scroll': 'เลื่อนลง',

  // Services Section
  'svc.eyebrow': 'บริการของเรา',
  'svc.title': 'บริการหลัก 4 ด้าน',
  'svc.sub': 'ครอบคลุมตั้งแต่ออกแบบเว็บไซต์ ระบบโมดูล ไปจนถึงสร้างแบรนด์ — โซลูชันดิจิทัลครบวงจร',
  'svc.c0.label': 'เว็บไซต์คัสตอม',
  'svc.c0.title': 'พัฒนาเว็บไซต์เฉพาะแบรนด์',
  'svc.c0.desc': 'จากกลยุทธ์ภาพลักษณ์สู่การพัฒนา Front-end เราสร้างเว็บไซต์ Responsive ที่สะท้อนแบรนด์ได้อย่างสมบูรณ์',
  'svc.c0.cta': 'ดูรายละเอียด',
  'svc.c0.f0': 'ออกแบบวิชวลเฉพาะตัว',
  'svc.c0.f1': 'Responsive ทุกอุปกรณ์',
  'svc.c0.f2': 'SEO เทคนิคขั้นสูง',
  'svc.c0.f3': 'โหลดเร็วสูงสุด',
  'svc.c0.f4': 'ทดสอบความปลอดภัยอัตโนมัติ',
  'svc.c1.label': 'คลังโมดูล',
  'svc.c1.title': 'ระบบ UI Design ที่ขยายได้',
  'svc.c1.desc': 'คอมโพเนนต์ UI คุณภาพสูงกว่า 130+ ชิ้น พร้อมใช้งาน รองรับการขยาย เร่งการพัฒนาได้ถึง 3 เท่า',
  'svc.c1.cta': 'ดูโมดูล',
  'svc.c1.f0': '100+ คอมโพเนนต์พรีเมียม',
  'svc.c1.f1': 'ระบบดีไซน์ที่สม่ำเสมอ',
  'svc.c1.f2': 'ลาก & วาง ได้ทันที',
  'svc.c1.f3': 'อัปเดตต่อเนื่อง',
  'svc.c2.label': 'อัตลักษณ์แบรนด์',
  'svc.c2.title': 'ออกแบบอัตลักษณ์แบรนด์',
  'svc.c2.desc': 'สร้างระบบภาพลักษณ์ครบวงจร ตั้งแต่ออกแบบโลโก้ถึง Brand Guidelines ทำให้แบรนด์โดดเด่นและน่าจดจำ',
  'svc.c2.cta': 'เรียนรู้เพิ่มเติม',
  'svc.c2.f0': 'ออกแบบโลโก้สร้างสรรค์',
  'svc.c2.f1': 'ระบบสีและตัวอักษร',
  'svc.c2.f2': 'ออกแบบการใช้งานแบรนด์',
  'svc.c2.f3': 'คู่มือ VI ครบถ้วน',
  'svc.c3.label': 'SEO & การตลาด',
  'svc.c3.title': 'SEO & การตลาดดิจิทัล',
  'svc.c3.desc': 'ผสาน Content Strategy และ Technical SEO เพื่อเพิ่มอันดับ ดึง Traffic คุณภาพ และเพิ่ม Conversion',
  'svc.c3.cta': 'เรียนรู้เพิ่มเติม',
  'svc.c3.f0': 'กลยุทธ์คีย์เวิร์ด',
  'svc.c3.f1': 'Core Web Vitals',
  'svc.c3.f2': 'Content Marketing',
  'svc.c3.f3': 'วิเคราะห์และรายงานผล',
  'svc.qa.eyebrow': 'มาตรฐานคุณภาพของเรา',
  'svc.qa.title': 'รับประกันความเสถียร ความปลอดภัย และประสิทธิภาพในทุกโซลูชัน',
  'svc.qa.sub': 'ระบบอัตโนมัติร่วมกับความเชี่ยวชาญของผู้เชี่ยวชาญ เราตรวจสอบทุกรายละเอียดเพื่อความเสถียรสูงสุดและการ Deploy ที่ไม่มีความเสี่ยง',
  'svc.qa0.title': '1,200+ Test Cases',
  'svc.qa0.text': 'สคริปต์อัตโนมัติครอบคลุมทุกฟีเจอร์ รับประกันทุก Update มีความมั่นคงสูงสุด',
  'svc.qa1.title': 'Launch ไร้ความเสี่ยง',
  'svc.qa1.text': 'สแกนช่องโหว่ OWASP ครบถ้วน รับรองว่าเว็บปลอดภัยสมบูรณ์ก่อน Go Live',
  'svc.qa2.title': 'ทดสอบ Performance',
  'svc.qa2.text': 'จำลอง Traffic สูงสุดเพื่อให้แน่ใจว่าเว็บเร็วและเสถียรทุกสถานการณ์',
  'svc.qa3.title': 'วิศวกร QA 8 คน',
  'svc.qa3.text': 'วิศวกร QA อาวุโสรับรองทุก Delivery — คุณภาพที่ไม่มีข้อยกเว้น',

  // Custom Website Section
  'cw.eyebrow': 'เว็บไซต์คัสตอม',
  'cw.titleL1': 'ประสบการณ์ดิจิทัลเฉพาะตัว',
  'cw.titleL2': '',
  'cw.sub': 'แบรนด์ของคุณสมควรได้มากกว่า Template เราออกแบบและพัฒนาเว็บไซต์เฉพาะที่จับเอกลักษณ์แบรนด์ได้อย่างสมบูรณ์แบบ',
  'cw.badge.label': 'เวลาส่งมอบเฉลี่ย',
  'cw.badge.value': 'ใช้งานได้ใน 8 สัปดาห์',
  'cw.f0.title': 'ออกแบบวิชวลเฉพาะตัว',
  'cw.f0.desc': 'สร้างสรรค์ให้ตรงกับ Tone และวิสัยทัศน์แบรนด์ ไม่มี Template ไม่มีการประนีประนอม',
  'cw.f1.title': 'Responsive ทุกอุปกรณ์',
  'cw.f1.desc': 'แสดงผลสมบูรณ์แบบบนมือถือ แท็บเล็ต และเดสก์ท็อป',
  'cw.f2.title': 'SEO เทคนิคขั้นสูง',
  'cw.f2.desc': 'ผ่าน Core Web Vitals พร้อมดันอันดับ Organic Search',
  'cw.f3.title': 'โหลดเร็วสูงสุด',
  'cw.f3.desc': 'โค้ดและมีเดียที่ Optimize แล้วเพื่อความเร็วสูงสุด',
  'cw.f4.title': 'ระบบ CMS ปรับแต่งได้',
  'cw.f4.desc': 'Backend ที่ใช้งานง่ายสำหรับอัปเดตคอนเทนต์ได้ตลอดเวลา',
  'cw.f5.title': 'ความปลอดภัยและบำรุงรักษา',
  'cw.f5.desc': 'SSL ระดับ Enterprise สำรองข้อมูลสม่ำเสมอ และซัปพอร์ตต่อเนื่อง',
  'cw.f6.title': 'ทดสอบอัตโนมัติมืออาชีพ',
  'cw.f6.desc': 'ตรวจสอบก่อน Launch อย่างเข้มข้น รับประกันความเสถียรและการ Deploy ไร้ความเสี่ยง',
  'cw.f6.badge': 'จุดเด่นสำคัญ',
  'cw.qa.eyebrow': 'การรับประกันคุณภาพ',
  'cw.qa.badge': 'การรับประกันคุณภาพ',
  'cw.qa.titleL1': 'ทุกเว็บไซต์ผ่าน',
  'cw.qa.titleL2': 'การทดสอบอัตโนมัติมืออาชีพ',
  'cw.qa.desc': 'ทีมวิศวกร QA ของเราใช้ Pipeline ทดสอบอัตโนมัติครบวงจร ตั้งแต่ Functional Testing, Security Scanning ไปจนถึง Performance Load Testing เพื่อให้เว็บ Launch ในสภาพที่เสถียรและปลอดภัยที่สุด',
  'cw.qs0.label': 'Test Cases อัตโนมัติ',
  'cw.qs1.label': 'สแกนความปลอดภัยก่อน Launch',
  'cw.qs2.label': 'ช่องโหว่ที่ทราบตอน Launch',
  'cw.qs3.label': 'วิศวกร QA ประจำ',
  'cw.tl.title': 'กระบวนการส่งมอบที่ชัดเจน',
  'cw.tl.sub': 'การเดินทาง 8 สัปดาห์ที่โปร่งใส คุณทราบความคืบหน้าและควบคุมทุกขั้นตอน',
  'cw.tl0.week': 'สัปดาห์ 1-2',
  'cw.tl0.phase': 'Discovery',
  'cw.tl0.desc': 'เจาะลึกคุณค่าหลักของแบรนด์ผ่านการวิจัยตลาดและวางตำแหน่งเชิงกลยุทธ์',
  'cw.tl1.week': 'สัปดาห์ 3-4',
  'cw.tl1.phase': 'ออกแบบวิชวล',
  'cw.tl1.desc': 'แปลงกลยุทธ์เป็นความงาม วนซ้ำแนวคิดดีไซน์จนตรงกับวิสัยทัศน์ของคุณ',
  'cw.tl2.week': 'สัปดาห์ 5-7',
  'cw.tl2.phase': 'พัฒนา',
  'cw.tl2.desc': 'แปลงดีไซน์เป็นโค้ดที่แข็งแกร่ง ผสาน CMS และปรับ Performance อย่างละเอียด',
  'cw.tl3.week': 'สัปดาห์ 8',
  'cw.tl3.phase': 'Launch',
  'cw.tl3.desc': 'Deploy อย่างสมบูรณ์แบบ พร้อมฝึกอบรมและซัปพอร์ตต่อเนื่อง',

  // Module Library
  'mod.eyebrow': 'คลังโมดูล',
  'mod.title': 'คลังโมดูลมืออาชีพ',
  'mod.sub': 'คอมโพเนนต์ UI คุณภาพสูงกว่า 130 ชิ้นใน 6 หมวด ออกแบบเพื่อประกอบได้รวดเร็วพร้อมรักษาความสม่ำเสมอของดีไซน์',
  'mod.hint': 'Hover ที่การ์ดเพื่อดูรายละเอียดโมดูล',
  'mod.c0.name': 'คอมโพเนนต์โครงสร้าง',
  'mod.c0.desc': 'Hero Banner, Content Grid และ Divider — ส่วนประกอบพื้นฐานสำหรับโครงสร้างหน้าที่แข็งแกร่ง',
  'mod.c0.unit': 'โมดูล',
  'mod.c0.i0': 'Hero Banner × 8',
  'mod.c0.i1': 'Page Layout × 6',
  'mod.c0.i2': 'Content Grid × 5',
  'mod.c0.i3': 'Split Screen × 5',
  'mod.c1.name': 'การนำทาง',
  'mod.c1.desc': 'Top Nav, Sidebar และ Mega Menu ที่ออกแบบนำทางผู้ใช้ได้อย่างราบรื่น',
  'mod.c1.unit': 'โมดูล',
  'mod.c1.i0': 'Top Nav × 6',
  'mod.c1.i1': 'Hamburger Menu × 4',
  'mod.c1.i2': 'Sidebar Nav × 4',
  'mod.c1.i3': 'Breadcrumbs × 4',
  'mod.c2.name': 'อีคอมเมิร์ซ',
  'mod.c2.desc': 'Product Card, ตะกร้าสินค้า และ Checkout ที่ Optimize เพื่อเพิ่ม Conversion สูงสุด',
  'mod.c2.unit': 'โมดูล',
  'mod.c2.i0': 'Product Card × 10',
  'mod.c2.i1': 'ตะกร้าสินค้า × 5',
  'mod.c2.i2': 'ขั้นตอน Checkout × 6',
  'mod.c2.i3': 'รายละเอียดสินค้า × 9',
  'mod.c3.name': 'ฟอร์มและการควบคุม',
  'mod.c3.desc': 'Input Field แบบ Interactive, Dropdown อัจฉริยะ และฟอร์มหลายขั้นตอนเพื่อเก็บข้อมูลได้อย่างมีประสิทธิภาพ',
  'mod.c3.unit': 'โมดูล',
  'mod.c3.i0': 'Text Input × 6',
  'mod.c3.i1': 'Dropdown × 5',
  'mod.c3.i2': 'File Upload × 4',
  'mod.c3.i3': 'Multi-Step Form × 7',
  'mod.c4.name': 'แสดงผลสื่อ',
  'mod.c4.desc': 'แกลเลอรีภาพ Carousel และ Video Player ที่นำเสนอสื่อภาพได้อย่างน่าประทับใจ',
  'mod.c4.unit': 'โมดูล',
  'mod.c4.i0': 'แกลเลอรีภาพ × 7',
  'mod.c4.i1': 'Video Player × 4',
  'mod.c4.i2': 'Carousel × 5',
  'mod.c4.i3': 'Lightbox × 4',
  'mod.c5.name': 'แสดงผลข้อมูล',
  'mod.c5.desc': 'Chart สวยงาม, Dashboard แบบ Interactive และ KPI Card สำหรับ Business Intelligence ที่ชัดเจน',
  'mod.c5.unit': 'โมดูล',
  'mod.c5.i0': 'Chart × 6',
  'mod.c5.i1': 'Progress Bar × 4',
  'mod.c5.i2': 'Dashboard × 3',
  'mod.c5.i3': 'KPI Card × 3',
  'mod.apply': 'สมัครใช้โมดูลนี้',
  'mod.cta.title': 'ต้องการโซลูชันเฉพาะ?',
  'mod.cta.sub': 'แจ้งความต้องการเฉพาะของคุณ ทีมเราจะพัฒนาโมดูลที่ตอบโจทย์ได้อย่างสมบูรณ์แบบ',
  'mod.cta.btn': 'ขอโมดูลเฉพาะ',

  // Brand Identity
  'br.eyebrow': 'อัตลักษณ์แบรนด์',
  'br.title': 'สร้างแบรนด์ที่ยั่งยืน',
  'br.sub': 'แบรนด์มากกว่าแค่ภาพ — มันคือการแสดงออกเชิงกลยุทธ์ของอัตลักษณ์หลักของคุณ เราสร้างระบบภาพลักษณ์ที่สอดคล้องกันและสร้างความประทับใจไม่รู้ลืม',
  'br.c0.title': 'ออกแบบโลโก้สร้างสรรค์',
  'br.c0.desc': 'เราถ่ายทอดคุณค่าหลักของแบรนด์สู่สัญลักษณ์ที่ทรงพลังและจดจำได้ ออกแบบให้ Scale ได้สมบูรณ์แบบทุก Medium',
  'br.c0.f0': 'เสนอแนวคิดหลายแบบ',
  'br.c0.f1': 'ส่งมอบในรูปแบบ Vector',
  'br.c0.f2': 'เวอร์ชัน B&W และสี',
  'br.c0.f3': 'รอบการแก้ไขที่มีโครงสร้าง',
  'br.c1.title': 'ระบบอัตลักษณ์ภาพ',
  'br.c1.desc': 'กำหนดจานสี ตัวอักษร และ Visual Asset อย่างเป็นระบบ เพื่อรับประกันความสม่ำเสมอในทุก Touchpoint',
  'br.c1.f0': 'แนวทางสีของแบรนด์',
  'br.c1.f1': 'ระบบตัวอักษร',
  'br.c1.f2': 'องค์ประกอบกราฟิกเฉพาะ',
  'br.c1.f3': 'คู่มือ VI ครบถ้วน',
  'br.c2.title': 'ออกแบบการใช้งานแบรนด์',
  'br.c2.desc': 'แปลงอัตลักษณ์สู่สื่อที่จับต้องได้ ตั้งแต่ Template ดิจิทัลถึงสื่อสิ่งพิมพ์พรีเมียม เพื่อให้แบรนด์โดดเด่นทุกที่',
  'br.c2.f0': 'ออกแบบ Stationery พรีเมียม',
  'br.c2.f1': 'Template การนำเสนอ',
  'br.c2.f2': 'Asset โซเชียลมีเดีย',
  'br.c2.f3': 'สื่อการตลาด',
  'br.proc.eyebrow': 'กระบวนการของเรา',
  'br.proc.title': 'กระบวนการออกแบบแบรนด์ 4 ขั้นตอน',
  'br.proc.sub': 'แนวทางที่เน้นกลยุทธ์เป็นอันดับแรก เพื่อแปลงวิสัยทัศน์หลักของคุณสู่อัตลักษณ์ภาพที่โดดเด่น',
  'br.proc0.title': 'วิจัยแบรนด์',
  'br.proc0.desc': 'ค้นหา DNA ของแบรนด์คุณ เราวิเคราะห์ตลาด กลุ่มเป้าหมาย และคู่แข่งเพื่อสร้างฐานกลยุทธ์ที่แข็งแกร่ง',
  'br.proc1.title': 'พัฒนาแนวคิด',
  'br.proc1.desc': 'แปลง Insight สู่สุนทรียะ เราสำรวจทิศทางดีไซน์ที่แตกต่างผ่าน Mood Board และ Sketch แนวคิด',
  'br.proc2.title': 'ขัดเกลาดีไซน์',
  'br.proc2.desc': 'ขัดเกลาวิสัยทัศน์ให้สมบูรณ์ ผ่านรอบการแก้ไขที่มีโครงสร้าง จนแนวคิดที่เลือกสะท้อนจิตวิญญาณของแบรนด์คุณ',
  'br.proc3.title': 'ส่งมอบแบรนด์',
  'br.proc3.desc': 'เตรียมความพร้อมสู่อนาคต เราส่งมอบคลัง Asset ครบถ้วนและ Guideline ที่ชัดเจนเพื่อการใช้แบรนด์ที่สมบูรณ์แบบ',
  'br.proc.cta': 'เริ่มโปรเจกต์แบรนด์',

  // Contact
  'ct.eyebrow': 'ติดต่อเรา',
  'ct.title': 'เริ่มโปรเจกต์ของคุณ',
  'ct.sub': 'แบ่งปันวิสัยทัศน์กับทีมของเรา เราจะตรวจสอบความต้องการและตอบกลับภายใน 1 วันทำการ',
  'ct.info0.label': 'ที่อยู่',
  'ct.info0.value': 'No.7 Xinyi Rd Sec.5, Xinyi Dist., Taipei',
  'ct.info1.label': 'อีเมล',
  'ct.info1.value': 'info@forwardthai.com',
  'ct.info2.label': 'โทรศัพท์',
  'ct.info2.value': '+886 2 2345 6789',
  'ct.info3.label': 'เวลาทำการ',
  'ct.info3.value': 'จันทร์–ศุกร์ 09:00–18:00 น.',
  'ct.social.title': 'ติดตามเรา',
  'ct.form.nameLabel': 'ชื่อ *',
  'ct.form.emailLabel': 'อีเมล *',
  'ct.form.serviceLabel': 'ประเภทบริการ',
  'ct.form.budgetLabel': 'งบประมาณ',
  'ct.form.messageLabel': 'รายละเอียดโปรเจกต์',
  'ct.form.namePlaceholder': 'ชื่อของคุณ',
  'ct.form.emailPlaceholder': 'your@email.com',
  'ct.form.msgPlaceholder': 'อธิบายความต้องการ เป้าหมาย และข้อกำหนดพิเศษของโปรเจกต์คุณ...',
  'ct.form.svcDefault': 'เลือกบริการ',
  'ct.form.svc0': 'ออกแบบเว็บไซต์คัสตอม',
  'ct.form.svc1': 'ออกแบบอัตลักษณ์แบรนด์',
  'ct.form.svc2': 'คลังโมดูล',
  'ct.form.svc3': 'SEO Optimization',
  'ct.form.svc4': 'อื่นๆ',
  'ct.form.bgtDefault': 'เลือกช่วงงบประมาณ',
  'ct.form.bgt0': 'ต่ำกว่า $1,500',
  'ct.form.bgt1': '$1,500 – $5,000',
  'ct.form.bgt2': '$5,000 – $10,000',
  'ct.form.bgt3': 'มากกว่า $10,000',
  'ct.form.submit': 'ส่งคำถาม',
  'ct.form.submitting': 'กำลังส่ง...',
  'ct.form.successTitle': 'ได้รับคำถามแล้ว',
  'ct.form.successDesc': 'ขอบคุณที่ติดต่อเรา ทีมของเราจะตรวจสอบรายละเอียดและติดต่อกลับภายใน 1 วันทำการ',
  'ct.form.refill': 'กลับสู่หน้าแรก',
  'ct.form.error': 'การส่งล้มเหลว กรุณาลองใหม่อีกครั้ง',

  // Footer
  'ft.desc': 'พาร์ทเนอร์ดิจิทัลสร้างสรรค์ของคุณ เชี่ยวชาญออกแบบแบรนด์ระดับองค์กร สร้างอัตลักษณ์ดิจิทัลที่เป็นเอกลักษณ์ด้วยดีไซน์ที่ประณีต',
  'ft.group0.title': 'บริการ',
  'ft.group0.l0': 'ออกแบบเว็บไซต์คัสตอม',
  'ft.group0.l1': 'อัตลักษณ์แบรนด์',
  'ft.group0.l2': 'คลังโมดูล',
  'ft.group0.l3': 'SEO & การตลาด',
  'ft.group0.l4': 'ดูแลเว็บไซต์',
  'ft.group1.title': 'แหล่งข้อมูล',
  'ft.group1.l0': 'บล็อกดีไซน์',
  'ft.group1.l1': 'ดูตัวอย่างโมดูล',
  'ft.group1.l2': 'คู่มือดีไซน์',
  'ft.group1.l3': 'Case Studies',
  'ft.group1.l4': 'คำถามที่พบบ่อย',
  'ft.group2.title': 'เกี่ยวกับเรา',
  'ft.group2.l0': 'เรื่องราวของเรา',
  'ft.group2.l1': 'ปรัชญาการออกแบบ',
  'ft.group2.l2': 'ทีมงาน',
  'ft.group2.l3': 'ร่วมงานกับเรา',
  'ft.group2.l4': 'ติดต่อ',
  'ft.legal0': 'นโยบายความเป็นส่วนตัว',
  'ft.legal1': 'ข้อกำหนดการใช้งาน',
  'ft.legal2': 'การตั้งค่า Cookie',
  'ft.tagline': 'Professional Digital Design Services',
  'ft.backtop': 'กลับสู่ด้านบน',
};
export default translations;
